function hasRoleDirective(securityService) {
	return {
		restrict : 'A',
		replace : true,
		link : function(scope, element, attrs) {
			if (!_.isString(attrs.hasRole)) {
				throw 'hasRole value must be a string'
			}

			function toggleVisibilityBasedOnHasRole() {
				if (securityService.hasRole(attrs.hasRole)) {
					element.show();
				} else {
					element.hide();
				}
			}

			toggleVisibilityBasedOnHasRole();
		}
	};
};

function hasNotRoleDirective($animate, $compile, securityService) {
	return {
		multiElement : true,
		transclude : 'element',
		priority : 600,
		terminal : true,
		restrict : 'A',
		$$tlb : true,
		link : function($scope, $element, $attr, ctrl, $transclude) {
			var block, childScope, previousElements;
			
			$scope.$watch($attr.hasNotRole, function hasNotRoleWatchAction(
					value) {
				
				if (!securityService.hasRole(value)) {
					if (!childScope) {
						$transclude(function(clone, newScope) {
							childScope = newScope;
							clone[clone.length++] = $compile.$$createComment(
									'end hasNotRole', $attr.hasNotRole);
							
							block = {
								clone : clone
							};
							$animate.enter(clone, $element.parent(), $element);
						});
					}
				} else {
					if (previousElements) {
						previousElements.remove();
						previousElements = null;
					}
					if (childScope) {
						childScope.$destroy();
						childScope = null;
					}
					if (block) {
						previousElements = getBlockNodes(block.clone);
						$animate.leave(previousElements).then(function() {
							previousElements = null;
						});
						block = null;
					}
				}

			});
		}

	};
};

function appVersion(version) {
	return function($scope, elm, attrs) {
		elm.text(version);
	};
};

module.directive('hasRole', [ 'securityService', hasRoleDirective ]).directive(
		'hasNotRole',
		[ '$animate', '$compile', 'securityService', 
				hasNotRoleDirective ]).directive('appVersion',
		[ 'version', appVersion ]);
